import React, { useState, useEffect } from "react";
import { Dropdown } from "semantic-ui-react";
import { Employee } from "../../../api";
import { useAuth } from "../../../hooks";

const employeeController = new Employee();

/**
 * value                      - _id del empleado seleccionado
 * onChange(id)               - llamado con el _id seleccionado
 * onEmployeeChange(employee) - llamado con el objeto completo (para extraer numero_legajo, etc.)
 */
export function SelectEmployee({ value, onChange, onEmployeeChange, placeholder = "Seleccionar empleado", fluid = true }) {
  const { accessToken } = useAuth();
  const [employees, setEmployees] = useState([]);
  const [options,   setOptions]   = useState([]);
  const [loading,   setLoading]   = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await employeeController.getEmployees(accessToken, { active: true });
        setEmployees(data);
        setOptions(
          data.map((e) => ({
            key:   e._id,
            value: e._id,
            text:  `${e.nombre} ${e.apellido}${e.numero_legajo ? ` (Leg. ${e.numero_legajo})` : ""}`,
          }))
        );
      } catch {
        setOptions([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const handleChange = (_, d) => {
    onChange(d.value);
    if (onEmployeeChange) {
      const found = employees.find((e) => e._id === d.value) || null;
      onEmployeeChange(found);
    }
  };

  return (
    <Dropdown
      selection
      search
      fluid={fluid}
      clearable
      placeholder={placeholder}
      options={options}
      value={value || ""}
      onChange={handleChange}
      loading={loading}
    />
  );
}
